const PRESENTATION_FIELD_CONFIG = [
  {
    fieldKey: 'from_display_name',
    editorId: 'email-from-display-name',
    settingsId: 'org-default-from-display-name',
    label: 'Sender display name',
    token: null,
    placeholder: 'e.g., Downtown Dermatology',
    maxLength: 255,
  },
  {
    fieldKey: 'reply_to',
    editorId: 'email-reply-to',
    settingsId: 'org-default-reply-to',
    label: 'Reply-To email',
    token: null,
    placeholder: 'e.g., frontdesk@clinic.com',
    maxLength: 254,
  },
  {
    fieldKey: 'scheduling_url',
    editorId: 'email-scheduling-url',
    settingsId: 'org-default-scheduling-url',
    label: 'Scheduling URL',
    token: '{{scheduling_link}}',
    missingTokenValueMessage: 'Add a scheduling URL (or set an organization default) because the email uses {{scheduling_link}}',
    placeholder: 'https://book.clinic.com',
    maxLength: 2048,
  },
  {
    fieldKey: 'practice_phone',
    editorId: 'email-practice-phone',
    settingsId: 'org-default-practice-phone',
    label: 'Practice phone',
    token: '{{practice_phone}}',
    missingTokenValueMessage: 'Add a practice phone (or set an organization default) because the email uses {{practice_phone}}',
    placeholder: '(555) 123-4567',
    maxLength: 50,
  },
];

export const PRESENTATION_FIELD_KEYS = PRESENTATION_FIELD_CONFIG.map(({ fieldKey }) => fieldKey);

export const presentationRecord = (valueForField) => (
  Object.fromEntries(PRESENTATION_FIELD_CONFIG.map((config) => (
    [config.fieldKey, valueForField(config)]
  )))
);

export const presentationValuesFrom = (source, fallback = null) => (
  presentationRecord(({ fieldKey }) => (
    source && Object.prototype.hasOwnProperty.call(source, fieldKey)
      ? source[fieldKey]
      : fallback
  ))
);

export const editablePresentationValuesFrom = (source) => (
  presentationRecord(({ fieldKey }) => source?.[fieldKey] || '')
);

export default PRESENTATION_FIELD_CONFIG;
